module.exports = __webpack_public_path__ + "/c910c94c874682ea3433eceb29a4494f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/upload_icon@2x.png
 ** module id = 814
 ** module chunks = 0 1
 **/